import { removeCustomerFromAccessHistory } from './customer_access_history';
import unloadCustomer from './unload_customer';

export default function (context, customerId) {
  if (context.stores.currentLocation.get().customerId !== customerId) {
    removeCustomerFromAccessHistory(context, customerId);
    unloadCustomer(context, customerId);
  }
}
